<section
  id="industries"
  class="industries services bg-blue-50 p-6 sm:p-8 m-1 md:m-8"
  style="border-radius: 30px;"
>
  <div class="px-6 sm:px-12 pb-8 sm:pb-12">
    <h2
      class="font-clashg text-lg text-left mt-4 uppercase font-bold text-DarkBlue"
    >
      Industrias
    </h2>
    <p
      class="font-clashg relative text-2xl md:text-5xl mt-2 font-medium text-left"
    >
      Destáquese En Su Industria
    </p>
    <p class="text-lg my-4 text-Gray">
      Brindamos soluciones especializadas para diversas industrias, adaptándonos
      a los retos únicos de cada sector.
    </p>

    <!-- Grid optimizado para móviles -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
      <!-- Industria 1 -->
      <div class="text-start bg-white border border-gray-400 p-4 rounded-xl">
        <img
          src="/Icons/medicina.svg"
          alt="Industria 1"
          class="h-10 w-10 mb-4 rounded-md sm:mx-0"
        />
        <h3 class="font-clashg mt-2 font-medium text-left text-3xl mb-2">
          Medicina
        </h3>
        <p class="text-md text-Gray">
          Proveemos soluciones de higiene y seguridad estrictamente reguladas
          para entornos médicos, garantizando un ambiente controlado y seguro
          para el personal y los pacientes.
        </p>
      </div>

      <!-- Industria 2 -->
      <div class="text-start bg-white border border-gray-400 p-4 rounded-xl">
        <img
          src="/Icons/mineria.svg"
          alt="Industria 2"
          class="h-10 w-10 mb-4 rounded-md sm:mx-0"
        />
        <h3
          class="font-clashg mt-2 font-medium text-left text-2xl sm:text-3xl mb-2"
        >
          Minería
        </h3>
        <p class="text-md text-Gray">
          Ofrecemos medidas de seguridad industrial para condiciones extremas en
          minería, asegurando el bienestar del equipo en un entorno exigente y
          de alto riesgo.
        </p>
      </div>

      <!-- Industria 3 -->
      <div class="text-start bg-white border border-gray-400 p-4 rounded-xl">
        <img
          src="/Icons/construccion.svg"
          alt="Industria 3"
          class="h-10 w-10 mb-4 rounded-md sm:mx-0"
        />
        <h3
          class="font-clashg mt-2 font-medium text-left text-2xl sm:text-3xl mb-2"
        >
          Construcción
        </h3>
        <p class="text-md text-Gray">
          Implementamos controles de higiene y seguridad en obras de
          construcción, minimizando riesgos y protegiendo a los trabajadores en
          cada etapa del proyecto.
        </p>
      </div>

      <!-- Industria 4 -->
      <div class="text-start bg-white border border-gray-400 p-4 rounded-xl">
        <img
          src="/Icons/metalurgica.svg"
          alt="Industria 4"
          class="h-10 w-10 mb-4 rounded-md sm:mx-0"
        />
        <h3
          class="font-clashg mt-2 font-medium text-left text-2xl sm:text-3xl mb-2"
        >
          Metalurgia
        </h3>
        <p class="text-md text-Gray">
          Desarrollamos soluciones personalizadas para el sector metalúrgico,
          enfocadas en la seguridad operativa y la reducción de la exposición a
          materiales peligrosos.
        </p>
      </div>

      <!-- Industria 5 -->
      <div class="text-start bg-white border border-gray-400 p-4 rounded-xl">
        <img
          src="/Icons/residuos.svg"
          alt="Industria 5"
          class="h-10 w-10 mb-4 rounded-md sm:mx-0"
        />
        <h3
          class="font-clashg mt-2 font-medium text-left text-2xl sm:text-3xl mb-2"
        >
          Tratamiento de Residuos
        </h3>
        <p class="text-md text-Gray">
          Brindamos soluciones integrales para la gestión de residuos, enfocadas
          en la higiene y el control de contaminantes para un entorno seguro y
          sustentable.
        </p>
      </div>

      <!-- Industria 6 -->
      <div class="text-start bg-white border border-gray-400 p-4 rounded-xl">
        <img
          src="/Icons/transporte.svg"
          alt="Industria 6"
          class="h-10 w-10 mb-4 rounded-md sm:mx-0"
        />
        <h3
          class="font-clashg mt-2 font-medium text-left text-2xl sm:text-3xl mb-2"
        >
          Transporte
        </h3>
        <p class="text-md text-Gray">
          Garantizamos prácticas de higiene y seguridad en el transporte de
          mercancías, protegiendo tanto a los operadores como a la carga en
          tránsito.
        </p>
      </div>
    </div>
  </div>
</section>
